import React, { useEffect, useState, useRef } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import {
  resourcesOperators,
  resourcesReports,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import { getStorageUser } from "../../../helpers/api_helper";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import ButtonHelper from "../../../helpers/ButtonHelper";
import Select from "react-select";

const reportTypeList = [
  { value: "operator", label: "Operador" },
  { value: "unit", label: "Unidad" },
];

const AsistenciaPorUnidadReport = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth() + 1 < 10 ? "0" : ""
    }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;
  const [date, setDate] = useState({ initDate: "", endDate: "" });
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "number",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateNow,
    operator_id: null,
    report_type: "unit",
  });
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const [selects, setSelects] = useState({ operators: [] });
  const [totals, setTotals] = useState({});

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesReports("show", params, "asistenciaUnidadReport").then(
      (response) => {
        setItems(response.data);
        setDataPag(response.meta);
        setPending(false);
        setTotals(response.totals);
      }
    );
  }, [filters]);
  const eleRef = useRef();

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesReports("show", config, "asistenciaUnidadReport").then(
      (response) => {
        if (type == 1) {
          console.log(response);
          const url = URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Reporte de asistencia por unidad.xlsx"
          );
          document.body.appendChild(link);
          link.click();
        } else {
          let nombre = "Archivo";
          var reader = new FileReader();
          reader.readAsDataURL(response);
          reader.fileName = nombre[1] || nombre[0];
          reader.onloadend = function (name) {
            name = nombre[0];
            var base64data = reader.result;
            setModal({ show: true, update: false, url: base64data });
          };
        }
      }
    );
  };

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true, orderBy: "name", order: "asc" } };
      const response = await resourcesOperators("get", params);
      setSelects({
        ...selects,
        operators: response.data,
      });
    };
    getSelects();
  }, []);

  useEffect(() => {
    const getSelects = async () => {
      let params = {
        params: { select: true, orderBy: "number", order: "asc" },
      };
      const response = await resourcesUnits("get", params);
      setUnits(response.data);
    };
    getSelects();
  }, []);

  const columns = Columns({ filters, fixDate: filters.initDate, baseCounter: filters.perPage * (filters.page - 1) });
  document.title = "Asistencias por unidad | Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Reporte de asistencias por unidad"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              filterInp={false}
              setFilters={setFilters}
              dense={true}
            >
              <ButtonHelper
                addButon={false}
                reportButons={true}
                actionReportButon={getReports}
                pdfButton={true}
              />
              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                getReports={getReports}
                modal={modal}
                setModal={setModal}
                endDate={false}
              />
              {filters.report_type === "operator" ? (
                <div className="col-sm-3">
                  <label className="form-label">Operador:</label>
                  <Select
                    placeholder="Seleccionar..."
                    style={{ padding: "01.25rem 0.5rem" }}
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={false}
                    name="week"
                    value={
                      selects.operators.find(
                        (e) => filters.operator_id == e.id
                      ) ?? null
                    }
                    options={selects.operators}
                    getOptionLabel={(option) => `${option.full_name}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setFilters({ ...filters, operator_id: e ? e.id : null }),
                    ]}
                  />
                </div>
              ) : (
                <div className="col-sm-3">
                  <label className="form-label">Unidad:</label>
                  <Select
                    placeholder="Seleccionar..."
                    style={{ padding: "01.25rem 0.5rem" }}
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={false}
                    name="week"
                    value={units.find((e) => filters.unit_id == e.id) ?? null}
                    options={units}
                    getOptionLabel={(option) => `${option.number}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={(e) => [
                      setFilters({ ...filters, unit_id: e ? e.id : null }),
                    ]}
                  />
                </div>
              )}
              <div className="col-sm-7 text-end pt-3">
                <b>
                  <br />
                  Total unidades con asistencia: {totals.unidadesAsistentes}
                </b>
              </div>
            </DataTableHelper>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AsistenciaPorUnidadReport;
